var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import StyledTooltipContainer from './StyledTooltipContainer';
var acceptedPositions = new Set(['top', 'left', 'right', 'bottom']);
var defaultPosition = 'top';
var ClydeTooltip = function (props) {
    var label = props.label, _a = props.position, position = _a === void 0 ? defaultPosition : _a, _b = props.hideIndicator, hideIndicator = _b === void 0 ? false : _b, children = props.children, // The "indicator" element if `hideIndicator=true`
    _c = props.containerClassName, // The "indicator" element if `hideIndicator=true`
    containerClassName = _c === void 0 ? '' : _c, // TODO: maybe we could ...rest this?
    show = props.show;
    var _d = useState(show || false), visible = _d[0], setVisible = _d[1];
    var _show = function () { return setVisible(true); };
    var _hide = function () { return setVisible(false); };
    React.useEffect(function () {
        if (show !== undefined) {
            setVisible(show);
        }
    }, [show]);
    var modalPosition = React.useMemo(function () {
        if (!acceptedPositions.has(position)) {
            return defaultPosition;
        }
        return position;
    }, [position]);
    var maybeRenderTooltip = function () {
        if (!visible) {
            return null;
        }
        return (React.createElement("div", { className: "clyde-tooltip clyde-tooltip--".concat(modalPosition) },
            React.createElement("div", { className: "clyde-tooltip--background" },
                React.createElement("div", { className: "clyde-tooltip--label" }, label)),
            React.createElement("div", { className: "clyde-tooltip--arrow" })));
    };
    var renderIndicator = function () {
        if (hideIndicator) {
            // TODO: this feels a little funny, because we aren't really "hiding" the indicator
            return children;
        }
        return React.createElement("button", { className: "clyde-tooltip--indicator" });
    };
    var _props = (show !== undefined) ? {} : {
        onMouseEnter: _show,
        onFocus: _show,
        onMouseLeave: _hide,
        onBlur: _hide,
    };
    return (React.createElement(StyledTooltipContainer, __assign({ className: "clyde-tooltip-container ".concat(containerClassName) }, _props),
        maybeRenderTooltip(),
        renderIndicator()));
};
export default ClydeTooltip;
